import React from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './auth/AuthContext';
import AppRoutes from './routes/AppRoutes';
import ErrorBoundary from './components/ErrorBoundary';

// Resets the boundary when the URL changes, so one broken page does not trap the rest of the app.
function GuardedRoutes() {
  const { pathname } = useLocation();
  return <ErrorBoundary resetKey={pathname}><AppRoutes /></ErrorBoundary>;
}

// App is only the providers. Auth state lives in auth/AuthContext.js, URLs in routes/paths.js,
// the route tree in routes/AppRoutes.js, and page chrome in layouts/.
function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <GuardedRoutes />
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
